module.exports = __webpack_public_path__ + "media/images/payment/transferwise-0a7f2dceb695be3b33961eeee5dccbed.svg";